var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"orders-entry",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('open')}}},[_vm._v("Мої замовлення")])
}
var staticRenderFns = []

export { render, staticRenderFns }